import * as React from 'react';
import _ from 'lodash';
import numeral from 'numeral';
import { Label } from '@mlc/web-ui-toolkit';
import { faDownload } from '@fortawesome/pro-regular-svg-icons';
import searchTestIds from '../../SearchResults.elements';
import * as Styled from './styled';
import DownloadCsv from '../../DownloadCsv/DownloadCsv';
import moment from 'moment';
import { getSearchResultList } from './getSearchResultList';
import { SearchFilterValues } from '../../../../../logic/domains/searchFilters.domain';
import { getSearchResultsForCSV } from '../../../../../logic/functions/advancedSearch.function';

interface SearchBarProps {
	totalCount: number;
	customerNumber: string;
	customerToken: string;
	searchFilters: SearchFilterValues;
}

export const getResultsCountTitle = (length: number) => {
	let resultCount = length > 0 ? numeral(length).format('0,0') : 'No';
	let resultText = length > 1 ? 'results' : 'result';
	resultText = length === 0 ? 'results' : resultText;
	return `${resultCount} ${resultText}`;
};

export const getCurrentDate = () => {
	return moment().format('YYYYMMDD');
};

const SearchBar: React.FunctionComponent<SearchBarProps> = ({
	customerNumber,
	customerToken,
	totalCount,
	searchFilters,
}) => {
	return (
		<Styled.SearchActionsContainer>
			<Label fontWeight="medium" data-id={searchTestIds.searchResultsCount}>
				{getResultsCountTitle(totalCount)}
			</Label>
			{totalCount > 0 ? (
				<Styled.ActionsContainer data-id={searchTestIds.searchResultsActions}>
					<DownloadCsv
						filterDataInCsvFormat={getSearchResultList}
						fetchDataToDownload={() =>
							getSearchResultsForCSV(customerToken, totalCount, searchFilters)
						}
						label="Download data"
						icon={faDownload}
						fileName={`searchResults_${customerNumber}_${getCurrentDate()}`}
						csvHeader={
							'Name,Customer ID/Plan number,Type,Address,Annual premiums,Total balance\n'
						}
					/>
				</Styled.ActionsContainer>
			) : null}
		</Styled.SearchActionsContainer>
	);
};

export default SearchBar;
